// TRƯỚC: static import tất cả → 970KB vào main bundle ngay lúc load
// SAU:   dynamic import theo ngôn ngữ → chỉ load đúng file cần

import enUS from 'antd/es/locale/en_US'
import frFR from 'antd/es/locale/fr_FR'
import viVN from 'antd/es/locale/vi_VN'

export const transToCorectCode = (code) => {
  switch (code) {
    case 'vi': return 'vi-VN'
    case 'fr': return 'fr-FR'
    default:   return 'en-US'
  }
}

// Antd locale vẫn static (nhỏ, ~10KB mỗi file, cần sẵn cho ConfigProvider)
export const getAntdLocale = (type) => {
  switch (type) {
    case 'vi': return viVN
    case 'fr': return frFR
    default:   return enUS
  }
}

// Lazy load translation theo ngôn ngữ — chỉ fetch khi cần
// Trả về Promise để caller dùng với await hoặc .then()
export const loadTranslation = (lang) => {
  switch (lang) {
    case 'vi': return import('./vi/vi_VN').then(m => m.default)
    case 'fr': return import('./fr/fr_FR').then(m => m.default)
    default:   return import('./en/en_US').then(m => m.default)
  }
}

// Giữ export default để không break caller nào đang dùng translations[lang]
// Nhưng đây là object rỗng — caller phải chuyển sang dùng loadTranslation()
export default {}